
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { TableHintDto } from "@moderrotech/servers-communication-library/src/types";
import { getTextDirection } from "@/helpers/string";
import { showToastError, showToastSuccess } from "@/helpers/notification";
import { i18n } from "@/lang";
import ProgressBar from "@/components/ProgressBar.vue";

// workaround to fix ts error
declare class ClipboardItem {
  constructor(data: { [mimeType: string]: Blob });
}

const tableRef = ref();

export default {
  components: { ProgressBar },
  setup() {
    const store = useStore();

    const tableHint = computed(
      (): TableHintDto => store.state.session.tableHint
    );

    const isPaused = ref(false);

    return {
      tableRef,
      tableHint,
      getTextDirection,
      handleCloseClick: () => store.commit("session/UNSET_TABLE_HINT"),
      handleCopyClick: async () => {
        try {
          /* eslint-disable */
          // @ts-ignore
          await window.navigator.clipboard.write([
            new ClipboardItem({
              "text/html": new Blob([tableRef.value?.outerHTML ?? ""], {
                type: "text/html"
              })
            })
          ]);
          /* eslint-enable */
          showToastSuccess(i18n.global.t("call.success.textCopy"));
        } catch (err) {
          showToastError(i18n.global.t("call.error.textCopy"));
        }
      },
      handleProgressEnd: () => store.commit("session/UNSET_TABLE_HINT"),
      isPaused
    };
  }
};
